<template>
  <v-card class="c metrics chart line">
    <v-card-text>
      <canvas ref="canvas"></canvas>
    </v-card-text>
  </v-card>
</template>

<script>
import Chart from 'chart.js';
import moment from 'moment';

export default {
  name: 'line-chart',

  props: {
    labels: {
      type: Array,
      required: true,
    },
    datasets: {
      type: Array,
      required: true,
    },
    dataLabel: {
      type: String,
      default: 'Data Label',
    },
    dataBackground: {
      type: String,
      default: 'transparent',
    },
    dataBorder: {
      type: String,
      default: '#2979FF',
    },
    xAxes: {
      type: Array,
      default: () => [{
        type: 'time',
        stacked: true,
        time: {
          min: moment().startOf('day'),
          max: moment().add(0.5, 'hours'),
          displayFormats: {
            hour: 'dd HH:mm',
          },
        },
      }],
    },
    yAxes: {
      type: Array,
      default: () => [{
        type: 'linear',
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: 'Auslastung in %',
        },
        ticks: {
          beginAtZero: false,
          max: 100,
          suggestedMin: 0,
          suggestedMax: 100,
        },
      }],
    },
  },

  data() {
    return {
      ctx: null,
      chart: null,
    };
  },

  watch: {
    datasets() {
      this.chart.data.datasets.data = this.datasets;
      // generate a completely new chart seems a bit of overhead.
      this.newLineChart();
      this.chart.update(0);
    },
    labels() {
      this.chart.data.labels = this.labels;
      // generate a completely new chart seems a bit of overhead.
      this.newLineChart();
      this.chart.update(0);
    },
  },

  methods: {
    newLineChart() {
      this.chart = new Chart(this.$refs.canvas, {
        type: 'line',
        data: {
          labels: this.labels,
          datasets: [{
            label: [this.dataLabel],
            data: this.datasets,
            pointBackgroundColor: this.dataBorder,
            pointBorderColor: this.dataBorder,
            pointBorderWidth: 3,
            backgroundColor: [this.dataBackground],
            fill: true,
            borderColor: [this.dataBorder],
            borderWidth: 4,
            lineTension: 0.01,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            mode: 'point',
            intersect: true,
          },
          scales: {
            xAxes: this.xAxes,
            yAxes: this.yAxes,
          },
        },
      });
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.ctx = this.$refs.canvas;
      this.newLineChart();
      this.$emit('load');
    });
  },

};
</script>
